const getScrollTop = () => (
  window.pageYOffset || 
    document.body.scrollTop || 
    document.documentElement.scrollTop
);

const ucfirst = string => string && string.charAt(0).toUpperCase() + string.slice(1);

export {
  getScrollTop,
  ucfirst
}


// WEBPACK FOOTER //
// ./src/shared/utils.js